import React from "react";
import { Styled } from "./styles";
import { Grid, Typography } from "@mui/material";
import constant from "@/utils/constant";
import { isArrayWithData } from "@/utils/validations";
import { useNavigate } from "react-router-dom";
import { Campaign } from "@/types/entities";
import { Button } from "@dippi/ui";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";

interface Props {
    data: Array<Partial<Campaign>>;
}

const CampaignsList: React.FC<Props> = ({ data }) => {
    const navigate = useNavigate();
    const SPACING = constant.GRID_SPACING;

    const onSelectCampaign = (code: string) => {
        navigate(`/campaigns/campaign/${code}`);
    };

    const onAddCampaign = () => {
        navigate(`/campaigns/campaign`);
    };

    return (
        <Styled.List container item direction="column" xs={12}>
            <Grid
                item
                xs="auto"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom={SPACING}
            >
                <Typography variant="h2">Campaigns</Typography>
                <Button variant="contained" onClick={onAddCampaign}>
                    Add campaign
                </Button>
            </Grid>
            <Grid item xs>
                {isArrayWithData(data) ? (
                    <Grid container item xs={12} gap={SPACING * 2}>
                        {data.map((i: Partial<Campaign>) => {
                            const { code, name, description, endDate } = i || {};
                            const isActive = endDate
                                ? new Date(endDate).setHours(23, 59, 59, 999) >=
                                  new Date().getTime()
                                : true;

                            return (
                                <Styled.Card
                                    key={code}
                                    isActive={isActive}
                                    onClick={() => onSelectCampaign(code as string)}
                                >
                                    <LocalActivityIcon sx={{ fontSize: "5rem" }} />
                                    <Typography variant="h6" gutterBottom>
                                        {name || "Untitled"}
                                    </Typography>
                                </Styled.Card>
                            );
                        })}
                    </Grid>
                ) : (
                    <Typography>No campaigns found</Typography>
                )}
            </Grid>
        </Styled.List>
    );
};

export default CampaignsList;
